import React, { type ReactNode } from "react";
import Skeleton from "src/components/Skeleton";
import { HeaderText, RegularText } from "src/components/v1/Text";
import { cn } from "src/utilities/shadcnUtils";

export interface CardProps {
  children: ReactNode;
  header?: ReactNode;
  subHeader?: ReactNode;
  className?: string;
  loading?: boolean;
}

const STYLES = {
  container: "rounded-[10px] border border-solid border-gray-400 inline-block overflow-visible",
  headerArea: "p-8",
  headerText: "font-bold text-[30px] leading-[45px] mb-4 max-[600px]:text-[28px]",
  subHeader: "text-lg",
};

const Card = ({ children, header, subHeader, className, loading, ...props }: CardProps) => (
  <div className={cn(STYLES.container, className)} {...props}>
    {header || subHeader ? (
      <div className={STYLES.headerArea}>
        {typeof header === "string" ? (
          <HeaderText className={STYLES.headerText}>{loading ? <Skeleton width="50%" /> : header}</HeaderText>
        ) : (
          header
        )}
        {typeof subHeader === "string" ? (
          <RegularText className={STYLES.subHeader}>{loading ? <Skeleton /> : subHeader}</RegularText>
        ) : (
          subHeader
        )}
      </div>
    ) : null}
    {children}
  </div>
);

export default React.memo(Card);
